<template>

  <div class="tweet-card-container">

    <div class="card-author-container">
      <div class="card-author-elements-top">
        <div class="card-author-profile">
          <img class="card-author-image" :src="profileImageUrl">
          <div class="card-author-name">
            <div class="card-name">{{name}}</div>
            <div style="opacity: 0.6; font-size: 12px;">@{{screenName}}</div>
          </div>
        </div>

        <template>
          <button v-if="hasLike()" @click="like" type="button" class="new-like-button" style="margin-right: 0px;">
            <span>{{likes.length}}</span>
            <i class="fas fa-caret-up new-like-button-icon"></i>
          </button>

          <button v-if="!hasLike()" @click="dislike" type="button" class="new-like-button" style="margin-right: 0px;">
            <span>{{likes.length}}</span>
            <i class="fas fa-caret-up new-like-button-icon"></i>
          </button>

          <button v-if="!$store.state.auth.isLogged" @click="$store.state.showLodingModal = true" type="button" class="new-like-button" style="margin-right: 0px;">
            <span>{{likes.length}}</span>
            <i class="fas fa-caret-up new-like-button-icon"></i>
          </button>
        </template>
      
      </div>
    </div>

    <div class="card-title-thread-container">
      <div class="card-title-thread">{{title}}</div>
      <div v-if="createdAt !== ''" style="font-size: 12px; opacity: 0.6;">{{createdAt.toDate().toDateString()}}</div>
    </div>

  <div style="background-color: var(--secondary-text-color); padding: 10px">

    <div class="card-thread-container">
      {{text}}
    </div>
    </div>


    <div class="card-tags-container">
      <button class="card-tags-button" @click="$router.push({ path: `/thread/${id}` })">Read 🧵</button>
      <div v-for="(t, i) in primaryTags" :key="`primary-tags-${i}`" class="card-tags">{{t}}</div>
      <div v-for="(t, i) in secondaryTags" :key="`secondary-tags-${i}`" class="card-tags">{{t}}</div>
    </div>
  
  </div>
  
</template>

<script>
import firebase from '@/firebase'

export default {
  props: [
    'id',
    'profileImageUrl', 
    'screenName', 
    'name', 
    'createdAt', 
    'title', 
    'text', 
    'primaryTags', 
    'secondaryTags',
    'authorId',
  ],

  data() {
    return {
      likes: [],
    }
  },

  mounted() {

  },

  methods: {
    async m() {
      const snap = await firebase.firestore.collection('threads2').doc(this.id).get()
      snap.docs[0].ref.collection('likes').get()
        .then(snap => {
          const likes = []
          for(const doc of snap.docs){
            const like = doc.data()
            like.id = doc.id
            likes.push(like)
          }
          this.likes = likes
        })
        .catch(e => console.error(e))
    },

    hasLike() {
        if(firebase.auth.currentUser == null){
          return false
        }
        const userId = firebase.auth.currentUser.uid
        const f = this.likes.find(l => l.id === userId)
        return f != null
      },

    like() {
      if(firebase.auth.currentUser == null){
        this.$store.state.showLoginModal = true
        return
      }

      const userId = firebase.auth.currentUser.uid
      this.likes.push({ id: userId })

      this.$store.commit('like', this.id)
    },

    dislike() {
      if(firebase.auth.currentUser == null){
        this.$store.state.showLoginModal = true
        return
      }
      
      const userId = firebase.auth.currentUser.uid

      const i = this.likes.findIndex(x => x.id == userId)
      this.likes.splice(i, 1)
      
      this.$store.commit('dislike', this.id)
    },
  },
}
</script>

<style scoped>
.card-author-image{
    border-radius: 50% !important;
    width: 30px;
}
.card-author-container{
  background-color: var(--secondary-light-color);
  border-radius: 8px 8px 0px 0px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.card-author-elements-top{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.card-author-profile{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.card-author-name{
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
  margin-right: 10px;
}
.card-name{
  font-size: 13px;
  font-weight: bold;
}

.tweet-card-container{
  margin-bottom: 10px;
  max-width: 300px;
}

.card-title-thread{
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  display: flex;
  align-items: center;
}
.card-title-thread-container{
  flex-basis: 100%;
  background-color: var(--secondary-text-color);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0rem;
}

.card-tags-container{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: var(--secondary-light-color);
  border-radius: 0px 0px 8px 8px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.card-tags-button{
  background-color: var(--primary-color);
  color: var(--primary-text-color);
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  padding: 5px 10px 5px 10px;
  border: 1px solid;
  border-color: transparent;
  border-radius: 5px;
  cursor: pointer;
  margin: 2px;
  margin-left: 0px;
  font-size: 12px;
}
.card-tags-button:hover{
  background-color: transparent;
  color: var(--primary-color);
  border-color: var(--primary-color);
  border: 1px solid;
}
.card-tags{
  background-color: var(--secondary-color);
  color: var(--secondary-text-color);
  text-align: center;
  padding: 5px 10px 5px 10px;
  text-decoration: none;
  border: 1px solid;
  border-color: transparent;
  border-radius: 5px;
  margin: 2px;
  font-size: 12px;
}

.card-thread-container{
  background-color: var(--secondary-text-color);
  border: 1px solid var(--secondary-light-color);
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 8px;
}

@media (max-width: 760px){
  .tweet-card-container{
    max-width: none;
  }
}

</style>